import React, { useState } from 'react';

const SubjectTags = () => {
  const [activeTag, setActiveTag] = useState(null);
  
  const subjects = [
    { name: "Mathematics", icon: "fas fa-calculator", className: "math" },
    { name: "Physics", icon: "fas fa-atom", className: "physics" },
    { name: "Chemistry", icon: "fas fa-flask", className: "chemistry" },
    { name: "Biology", icon: "fas fa-dna", className: "biology" },
    { name: "English", icon: "fas fa-language", className: "english" },
    { name: "ICT", icon: "fas fa-laptop-code", className: "ict" },
    { name: "Science", icon: "fas fa-microscope", className: "science" },
    { name: "History", icon: "fas fa-landmark", className: "history" },
    { name: "Bangla", icon: "fas fa-book", className: "bangla" }
  ];

  const handleTagClick = (subjectName) => {
    setActiveTag(subjectName);
    console.log('Filtering by subject:', subjectName);
  };

  return (
    <div className="subject-tags-container">
      {subjects.map((subject, index) => (
        <div 
          key={index}
          className={`subject-tag ${subject.className} ${activeTag === subject.name ? 'active' : ''}`}
          onClick={() => handleTagClick(subject.name)}
        >
          <i className={subject.icon}></i> {subject.name}
        </div>
      ))}
    </div>
  );
};

export default SubjectTags;